import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withEditFunctionality } from 'components/Portfolio/PortfolioAbout/components/hoc/withEditFunctionality';
import {
  DISPLAYNAME_MAX_LENGTH,
  getDisplaynameFormatError,
} from 'helpers/displaynameValidation';
import styles from './DisplaynameSection.module.scss';

class DisplaynameBase extends Component {
  static propTypes = {
    data: PropTypes.string,
    editMode: PropTypes.bool,
    isOwner: PropTypes.bool,
    toggleEditMode: PropTypes.func,
    updateData: PropTypes.func,
    user: PropTypes.any,
  };

  render() {
    const { data: displayName, editMode, user, updateData } = this.props;

    const formatError = getDisplaynameFormatError(displayName);

    return editMode ? (
      <span id="portfolio-displayname">
        <input
          className={`form-control ${styles.nameInput}`}
          aria-label="Your name"
          maxLength={DISPLAYNAME_MAX_LENGTH}
          size={Math.max(displayName.length + 2, 12)}
          value={displayName}
          onChange={({ target: { value } }) => updateData(value)}
        />
        {formatError && (
          <span className={`text-danger ${styles.nameError}`}>
            {formatError}
          </span>
        )}
      </span>
    ) : (
      <h1 id="portfolio-displayname" className={styles.displayName}>
        {user.displayname}
      </h1>
    );
  }
}

const Displayname = withEditFunctionality(DisplaynameBase);

export default Displayname;
